import { render, staticRenderFns } from "./SettingsUsers.vue?vue&type=template&id=20e61e59&scoped=true&"
import script from "./SettingsUsers.vue?vue&type=script&lang=ts&"
export * from "./SettingsUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e61e59",
  null
  
)

export default component.exports